import React from 'react';
import styles from './styles.module.css';
import { useTranslation } from "react-i18next";
import { Colors, ObjectUtils } from '#/utils/utils';
import { FieldType } from './types';
import FloatingTooltip from '#/components/FloatingTooltip/index';

function openOperationDesk(id) {
  window.open(`${window.originHost}/#/operationdesk?personId=${id}`, "_blank");
}

function renderCompositeCell({ baseObject, column, index, exhibition}) {
  const { t } = useTranslation();

  const generateRandomColor = index => {
    const colors = Colors.randomColors(exhibition || 10);
    return colors[index];
  }

  const avatarField = column.fields.find(f => f.type === FieldType.IMAGE);
  const idField = column.fields.find(f => f.type === FieldType.NUMBER);

  const textFields = column.fields
  .filter(field => field.type === FieldType.TEXT)
  .sort((primary, second) => {
    return (typeof primary.ordination === FieldType.NUMBER ? primary.ordination : 0) 
    - (typeof second.ordination === FieldType.NUMBER ? primary.ordination : 0);
  });

  const title = textFields[0] ? baseObject[textFields[0].key] : '';
  const description = textFields[1] ? baseObject[textFields[1].key] : '';
  const imagePath = avatarField ? baseObject[avatarField.key] : null;
  const id = idField ? baseObject[idField.key] : null;

  const initials = title && title.length >= 2 ? title[0] + title[1] : (title && title[0]) || '';

  return (
    <div className={styles.compositeCell}>
      {avatarField && (
        imagePath ? (
          <img src={imagePath} alt={t('PROFILE_PHOTO')} className={styles.avatar} />
        ) : (
          <div
            className={styles.initials}
            style={{ backgroundColor: generateRandomColor(index, exhibition) }}
          >
            {initials}
          </div>
        )
      )}
      <div className={styles.compositeText}>
        <FloatingTooltip content={title}>
          <span
            className={id ? styles.operationDeskLink : styles.title}
            {...(id ? { onClick: () => openOperationDesk(id) } : {})}
          >
            {ObjectUtils.abbreviationText(title)}
          </span>
        </FloatingTooltip>
        <p className={styles.description}>{description}</p>
      </div>
    </div>
  );
}

export default renderCompositeCell